import IconButton from '@/global/components/Button/IconButton'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import dayjs from 'dayjs'
import { Button } from 'global/components/Button'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import Cookies from 'js-cookie'
import { DownloadIcon, FilePlusIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { AEJ, aej } from 'service/api'
import { useStore } from 'store'

export default function GerarAej() {
    const empresaId = useStore(state => state.companyId)
    const { data = [], isLoading } = aej.useFetch({
        queryParams: {
            empresaId,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Integrações', 'AEJ']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    loading={isLoading}
                    columns={[
                        {
                            field: 'filename',
                            headerName: 'Nome do arquivo',
                            flex: 1,
                        },
                        {
                            field: 'dataInicial',
                            headerName: 'Data inicial',
                            width: 210,
                            align: 'right',
                            headerAlign: 'right',
                            valueFormatter: params =>
                                dayjs(params.value).format('DD/MM/YYYY'),
                        },
                        {
                            field: 'dataFinal',
                            headerName: 'Data final',
                            width: 210,
                            align: 'right',
                            headerAlign: 'right',
                            valueFormatter: params =>
                                dayjs(params.value).format('DD/MM/YYYY'),
                        },
                        {
                            field: 'createdAt',
                            headerName: 'Data de criação',
                            width: 300,
                            align: 'right',
                            headerAlign: 'right',
                            valueFormatter: params =>
                                dayjs(params.value).format('DD/MM/YYYY HH:mm'),
                        },
                        {
                            ...optionsColumn,
                            field: '__baixar',
                            renderCell: ({ row }) => (
                                <IconButton
                                    title="Baixar relatório"
                                    onClick={() => downloadAej(row)}
                                >
                                    <DownloadIcon />
                                </IconButton>
                            ),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(['delete', 'AEJ'], () => (
                                    <IconButton
                                        title="Excluir"
                                        href={`${id}/excluir`}
                                    >
                                        <Trash2Icon className="text-error" />
                                    </IconButton>
                                )),
                        },
                    ]}
                    rows={data}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-aej',
                        },
                    }}
                    components={{
                        Toolbar: () =>
                            hasPermission(['create', 'AEJ']) ? (
                                <>
                                    <div style={{ flex: 1 }} />
                                    <Button
                                        startIcon={<FilePlusIcon />}
                                        href="relatorio"
                                    >
                                        Gerar relatório...
                                    </Button>
                                </>
                            ) : null,
                    }}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

function downloadAej({ filename }: { filename: string }) {
    const url = `${import.meta.env.VITE_BASE_URL}/v1/aej/${filename}`
    const token = Cookies.get('JWT')

    fetch(url, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    })
        .then(response => response.blob())
        .then(blob => {
            const url = window.URL.createObjectURL(new Blob([blob]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()

            link.parentNode?.removeChild(link)

            window.URL.revokeObjectURL(url)
        })
}

export function useAejOutletContext() {
    return useOutletContext<{
        data: AEJ[]
    }>()
}
